import { createSlice } from "@reduxjs/toolkit";

const inventorySpareFilterSlice = createSlice({
  name: "inventorySpareFilter",
  initialState: {
    seller_id: "", 
    status: "",
  },
  reducers: {
    setInventorySparesFilter: (state, action) => {
      Object.assign(state, action.payload);
    },
  },
});

export const { setInventorySparesFilter } = inventorySpareFilterSlice.actions;

export const selectInventorySpareFilterState = (state) =>
  state.inventorySpareFilter;

export default inventorySpareFilterSlice.reducer;
